import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgEyeIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M6.4 30.056v3.888C7.89 36.256 16.26 48 32 48s24.11-11.744 25.6-14.056v-3.888C56.11 27.744 47.74 16 32 16S7.89 27.744 6.4 30.056m-2.722-1.683C5.224 25.96 14.433 12.8 32 12.8s26.777 13.16 28.323 15.574c.331.517.477 1.097.477 1.656v3.94c0 .559-.146 1.139-.477 1.657C58.776 38.04 49.567 51.2 32 51.2S5.224 38.04 3.678 35.626A3.06 3.06 0 0 1 3.2 33.97v-3.94c0-.559.146-1.139.478-1.657M32 25.6a6.4 6.4 0 1 0 0 12.8 6.4 6.4 0 0 0 0-12.8M22.4 32a9.6 9.6 0 1 1 19.2 0 9.6 9.6 0 0 1-19.2 0"
    />
  </svg>
)
export default SvgEyeIcon
